import { useMutation } from '@tanstack/react-query';
import { recordGamifyDesktopAppDownloadClicked } from '../api/trials';
import { invalidateGamifyTrialExtension } from '../query/useQueryGamifyTrialExtension';

export function useMutateRecordGamifyDesktopAppDownloadClicked() {
  return useMutation({
    mutationKey: ['record_gamify_desktop_app_download_clicked'],
    mutationFn: async () => {
      await recordGamifyDesktopAppDownloadClicked();
    },
    onSuccess: () => {
      void invalidateGamifyTrialExtension();
    },
  });
}
